import { toRef, watch } from 'vue';
import Core from '@/core/core/core';
import { dateFormat } from '@/core/utils/date';

import css from '@/components/forms/inputDate/datepicker.css?inline';

Core.insertStyleToPage(css);

const $ = (el: HTMLInputElement) => {
	if (!Core.$?.ui?.datepicker) {
		console.info('Для работы datepicker требуется глобальная загрузка jQuery UI Datepicker');

		return;
	}

	Core.$.datepicker.setDefaults({
		dateFormat: Core.state.dateFormat.toLowerCase().replace('m', 'mm').replace('y', 'yy').replace('d', 'dd'),
	});

	return Core.$(el);
};

export function connectDatepicker(el: HTMLInputElement, options: any) {
	return $(el)?.datepicker(options);
}

let dateFormatted;
let delimiter: string;
let dateNumbersCount: number;
let delimitersIndexes: number[];

watch(toRef(Core.state.dateFormat), () => {
	// генерация отформатированной даты, извлечение из нее разделителей и их индексов
	dateFormatted = dateFormat('2000-01-01');
	delimiter = dateFormatted.match(/\D/)?.[0] ?? '-';
	dateNumbersCount = dateFormatted.replace(/\D+/g, '').length;
	delimitersIndexes = [];

	for (let i = 0; i < dateFormatted.length; i++) {
		if (dateFormatted[i] === delimiter) {
			delimitersIndexes.push(i);
		}
	}
}, { immediate: true });

/**
 * Автоформат при вводе в поле с датой
 */
export function oninput(e: any) {
	let selectionPos = e.target.selectionEnd;
	let value = e.target.value;

	// разбить занчение на две половины - до и после каретки
	// удалить все символы, кроме цифр
	let valueChunkLeft = value.substring(0, selectionPos).replace(/\D+/g, '');
	let valueChunkRight = value.substring(selectionPos).replace(/\D+/g, '');

	let extraNumbersCount = valueChunkLeft.length + valueChunkRight.length - dateNumbersCount;
	if (extraNumbersCount > 0) {
		// // количество цифр больше требуемого - удалить лишние
		valueChunkLeft = valueChunkLeft.substring(0, dateNumbersCount);

		const valueChunkRightMaxLength = dateNumbersCount - valueChunkLeft.length;
		valueChunkRight = valueChunkRight.substring(valueChunkRight.length - valueChunkRightMaxLength);
	} else if (extraNumbersCount < 0) {
		// количество цифр меньше требуемого - добавить 0
		if (e.inputType === 'deleteContentForward') {
			// нажатие на delete - добавить к левой части для правильного позиционирования каретки
			valueChunkLeft += '0'.repeat(-extraNumbersCount);
		} else {
			valueChunkRight = '0'.repeat(-extraNumbersCount) + valueChunkRight;
		}
	}

	selectionPos = valueChunkLeft.length;
	value = valueChunkLeft + valueChunkRight;

	// вставить разделители
	for (let i = 0; i < delimitersIndexes.length; i++) {
		const delimiterIndex = delimitersIndexes[i];

		value = value.substring(0, delimiterIndex) + delimiter + value.substring(delimiterIndex);

		// сдвинуть каретку, если разделитель вставлен левее ее
		if (selectionPos >= delimiterIndex) {
			selectionPos++;
		}
	}

	// нажатие на backspace - если слева символ разделителя, перенести каретку за него
	if (e.inputType === 'deleteContentBackward' && value[selectionPos - 1] === delimiter) {
		selectionPos--;
	}

	// если значение изменилось - вставить его и переместить каретку
	if (value !== e.target.value) {
		e.target.value = value;
		e.target.selectionStart = selectionPos;
		e.target.selectionEnd = selectionPos;
	}
}
